import { AnyAction } from "redux";
import { FetchStatus, IFetchAction } from "../middleware/fetch-middleware";
import { IJobSearchResults, IJobSearchRequest, IJobSearchResult } from "../DTO/job-search";

export enum JobSearchApiActions {
    GetJobSearchResults = 'apiSearchResultsActions/getSearchResults',
}

export interface JobSearchApiState {
    jobSearchResults: IJobSearchResults,
}

const DefaultJobSearchApiState: JobSearchApiState = {
    jobSearchResults: Object.freeze({
        results: [] as IJobSearchResult[],
        totalResults: 0
    } as IJobSearchResults),
}

export const jobSearchApiReducer = (state = DefaultJobSearchApiState, action: AnyAction) => {
    switch (action.type) {
        case JobSearchApiActions.GetJobSearchResults + FetchStatus.Complete:
            return { ...state, jobSearchResults: JSON.parse(action.data) };
        default: return state;
    }
}

const BaseUrl = '/api/v1/jobsearch';

export const getJobSearchResults = (criteria: IJobSearchRequest): IFetchAction => ({
    type: JobSearchApiActions.GetJobSearchResults,
    fetch: new Request(`${BaseUrl}/results`, {
        method: 'POST',
        headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
        body: JSON.stringify(criteria)
    })
})

export const DefaultJobSearchResults: IJobSearchResults = {
    results: [],
    totalResults: 0
}